var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "#C0C8D7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60957 4.98296C3.09881 6.61375 4.63755 7.79082 5.98204 7.82851H5.99436V7.82923C5.99581 7.82851 5.99726 7.82851 5.99944 7.82851C6.00089 7.82851 6.00234 7.82851 6.00451 7.82923V7.82851H6.01611C7.3606 7.79082 8.89934 6.61375 9.3893 4.98296C9.60819 4.97209 9.84665 4.65391 9.94305 4.22483C10.0481 3.75589 9.94305 3.33261 9.70821 3.28042C9.64298 3.2652 9.57412 3.28259 9.50672 3.32318C9.24942 1.44162 7.78461 0 6.01611 0C6.01031 0 6.00524 0 5.99944 0C5.99364 0 5.98784 0 5.98204 0C4.21354 0 2.74873 1.44162 2.49143 3.32318C2.42475 3.28259 2.3559 3.2652 2.28994 3.28042C2.05511 3.33261 1.95074 3.75589 2.05511 4.22483C2.1515 4.65391 2.38996 4.97209 2.60957 4.98296Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9891 13.2013C11.6789 11.2161 10.3844 9.55632 8.61878 8.73077C8.10781 9.31061 7.16267 9.70055 6.0791 9.70055C6.05446 9.70055 6.02982 9.6991 6.00518 9.6991V9.69837H6.0001H5.99503V9.6991C5.97039 9.6991 5.94574 9.70055 5.9211 9.70055C4.83681 9.70055 3.8924 9.31061 3.38142 8.73077C1.61582 9.55632 0.321336 11.2161 0.0111237 13.2013C-0.0599061 13.6521 0.215516 14.0848 0.657641 14.2581C2.22537 14.8756 4.04823 15.23 5.99503 15.2315H6.0001H6.00518C7.95197 15.23 9.77483 14.8756 11.3426 14.2581C11.784 14.0848 12.0594 13.6521 11.9891 13.2013Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.29a47f4e8810af2038e036c9fa976cfe.svg";
export { ForwardRef as ReactComponent };